import AppManagerClient from '../../api/AppManagerClient';
import { IManagingLinuxServiceInstance } from '../../api/models';
import React, { useEffect, useState } from 'react';
import { LinuxServiceInfoView } from './LinuxServiceInfoView';
import { Merger } from '../../helpers/Merger';

interface LinuxServiceInfoProps {
    applicationName: string;
}
export const LinuxServiceInfo = ({ applicationName }: LinuxServiceInfoProps) => {
    const [serverApps, setServerApps] = useState<IManagingLinuxServiceInstance[]>([]);
    const [isLoading, setLoadingStatus] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const getServerApps = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getLinuxServiceForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServerApps(applicationName);
    }, [applicationName]);

    return (
        <LinuxServiceInfoView
            serverApp={Merger.merge(serverApps)}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isDataNotFound={serverApps.length === 0}
            applicationName={applicationName}
        />
    );
};
